// AUTO-GENERATED by gen-manifest.mjs — do not edit by hand.
// The set of screenshot paths (relative to /screenshots) that have a real image.
export const CAPTURED = new Set<string>([
  "account/audit-logs/01.png",
  "account/audit-logs/02.png",
  "account/billing-and-licenses/01.png",
  "account/billing-and-licenses/02.png",
  "account/billing-and-licenses/03.png",
  "account/developer/01.png",
  "account/developer/02.png",
  "account/developer/03.png",
  "account/downloads/01.png",
  "account/downloads/03.png",
  "account/profile-and-preferences/01.png",
  "account/profile-and-preferences/02.png",
  "account/profile-and-preferences/03.png",
  "account/profile-and-preferences/04.png",
  "account/proof-of-play/01.png",
  "account/proof-of-play/02.png",
  "account/proof-of-play/03.png",
  "account/proof-of-play/04.png",
  "account/roles-and-permissions/01.png",
  "account/roles-and-permissions/02.png",
  "account/roles-and-permissions/03.png",
  "account/screen-settings/01.png",
  "account/screen-settings/02.png",
  "account/screen-settings/03.png",
  "account/single-sign-on/01.png",
  "account/single-sign-on/02.png",
  "account/single-sign-on/03.png",
  "account/single-sign-on/04.png",
  "account/space-people/01.png",
  "account/users-and-invitations/01.png",
  "account/users-and-invitations/02.png",
  "account/users-and-invitations/03.png",
  "account/users-and-invitations/04.png",
  "account/who-sees-what/01.png",
  "account/who-sees-what/02.png",
  "apps/add-an-app/01.png",
  "apps/add-an-app/02.png",
  "apps/add-an-app/03.png",
  "apps/add-an-app/04.png",
  "apps/air-quality/01.png",
  "apps/air-quality/02.png",
  "apps/air-quality/03.png",
  "apps/ask-a-question/01.png",
  "apps/ask-a-question/02.png",
  "apps/bell-schedule/01.png",
  "apps/bell-schedule/02.png",
  "apps/bell-schedule/03.png",
  "apps/building-directory/01.png",
  "apps/building-directory/02.png",
  "apps/building-directory/03.png",
  "apps/business-finance-news/01.png",
  "apps/business-finance-news/02.png",
  "apps/calendar-for-google/01.png",
  "apps/calendar-for-google/02.png",
  "apps/calendar-for-google/03.png",
  "apps/campus-directory/01.png",
  "apps/campus-directory/02.png",
  "apps/campus-directory/03.png",
  "apps/canva/01.png",
  "apps/canva/02.png",
  "apps/canva/03.png",
  "apps/clinic-door/01.png",
  "apps/clinic-door/02.png",
  "apps/clinic-door/03.png",
  "apps/clock/01.png",
  "apps/clock/02.png",
  "apps/countdown-timer/01.png",
  "apps/countdown-timer/02.png",
  "apps/countup-timer/01.png",
  "apps/countup-timer/02.png",
  "apps/currencies/01.png",
  "apps/currencies/02.png",
  "apps/date/01.png",
  "apps/date/02.png",
  "apps/digital-menu-board/01.png",
  "apps/digital-menu-board/02.png",
  "apps/digital-signs/01.png",
  "apps/digital-signs/02.png",
  "apps/digital-signs/03.png",
  "apps/embed/01.png",
  "apps/embed/02.png",
  "apps/entertainment-news/01.png",
  "apps/entertainment-news/02.png",
  "apps/event-board/01.png",
  "apps/event-board/02.png",
  "apps/event-board/03.png",
  "apps/follow-us/01.png",
  "apps/follow-us/02.png",
  "apps/google-alerts/01.png",
  "apps/google-alerts/02.png",
  "apps/google-sheets/01.png",
  "apps/google-sheets/02.png",
  "apps/google-sheets/03.png",
  "apps/google-slides/01.png",
  "apps/google-slides/02.png",
  "apps/google-slides/03.png",
  "apps/headline-news/01.png",
  "apps/headline-news/02.png",
  "apps/hotel-directory/01.png",
  "apps/hotel-directory/02.png",
  "apps/hotel-directory/03.png",
  "apps/hotel-welcome/01.png",
  "apps/hotel-welcome/02.png",
  "apps/hotel-welcome/03.png",
  "apps/live-sources/01.png",
  "apps/live-sources/02.png",
  "apps/meet-the-team/01.png",
  "apps/meet-the-team/02.png",
  "apps/meet-the-team/03.png",
  "apps/meet-the-team/04.png",
  "apps/meeting-room-display/01.png",
  "apps/meeting-room-display/02.png",
  "apps/meeting-room-display/03.png",
  "apps/natural-world-news/01.png",
  "apps/natural-world-news/02.png",
  "apps/news-scroller/01.png",
  "apps/news-scroller/02.png",
  "apps/news-scroller/03.png",
  "apps/noticeboard/01.png",
  "apps/noticeboard/02.png",
  "apps/outlook-calendar/01.png",
  "apps/outlook-calendar/02.png",
  "apps/outlook-calendar/03.png",
  "apps/page-scroll/01.png",
  "apps/page-scroll/02.png",
  "apps/page-scroll/03.png",
  "apps/postermywall/01.png",
  "apps/postermywall/02.png",
  "apps/postermywall/03.png",
  "apps/power-bi/01.png",
  "apps/power-bi/02.png",
  "apps/power-bi/03.png",
  "apps/prayer-time/01.png",
  "apps/prayer-time/02.png",
  "apps/prayer-time/03.png",
  "apps/promo-wall/01.png",
  "apps/promo-wall/02.png",
  "apps/qr-code/01.png",
  "apps/qr-code/02.png",
  "apps/qr-code/03.png",
  "apps/queue-kiosk/01.png",
  "apps/queue-kiosk/02.png",
  "apps/queue-kiosk/03.png",
  "apps/queue-now-serving/01.png",
  "apps/queue-now-serving/02.png",
  "apps/queue-now-serving/03.png",
  "apps/rss-feed/01.png",
  "apps/rss-feed/02.png",
  "apps/social-reviews/01.png",
  "apps/social-reviews/02.png",
  "apps/sports-news/01.png",
  "apps/sports-news/02.png",
  "apps/technology-news/01.png",
  "apps/technology-news/02.png",
  "apps/transport/01.png",
  "apps/wayfinding/01.png",
  "apps/wayfinding/02.png",
  "apps/weather/01.png",
  "apps/website-url/01.png",
  "apps/website-url/02.png",
  "apps/website-url/03.png",
  "apps/world-clock/01.png",
  "apps/world-clock/02.png",
  "apps/youtube-live/01.png",
  "apps/youtube-live/02.png",
  "apps/youtube-live/03.png",
  "apps/youtube/01.png",
  "apps/youtube/02.png",
  "apps/youtube/03.png",
  "content/add-subtitles/01.png",
  "content/add-subtitles/02.png",
  "content/add-subtitles/03.png",
  "content/add-subtitles/04.png",
  "content/add-subtitles/05.png",
  "content/build-a-playlist/01.png",
  "content/build-a-playlist/02.png",
  "content/build-a-playlist/03.png",
  "content/build-a-playlist/04.png",
  "content/build-a-playlist/05.png",
  "content/build-a-playlist/06.png",
  "content/create-a-channel/01.png",
  "content/create-a-channel/02.png",
  "content/create-a-channel/03.png",
  "content/create-a-channel/04.png",
  "content/create-a-channel/05.png",
  "content/create-a-channel/06.png",
  "content/create-a-channel/07.png",
  "content/design-in-canvas/01.png",
  "content/design-in-canvas/02.png",
  "content/design-in-canvas/03.png",
  "content/design-in-canvas/04.png",
  "content/embed-on-website/01.png",
  "content/embed-on-website/02.png",
  "content/upload-media/01.png",
  "content/upload-media/02.png",
  "content/upload-media/03.png",
  "content/upload-media/04.png",
  "content/upload-media/05.png",
  "content/upload-media/06.png",
  "getting-started/first-screen-first-content/01.png",
  "getting-started/first-screen-first-content/02.png",
  "getting-started/first-screen-first-content/03.png",
  "getting-started/get-help-from-support/01.png",
  "getting-started/get-help-from-support/02.png",
  "getting-started/get-help-from-support/03.png",
  "getting-started/get-help-from-support/04.png",
  "getting-started/invite-your-team/02.png",
  "getting-started/invite-your-team/03.png",
  "getting-started/welcome-tour/01.png",
  "getting-started/welcome-tour/02.png",
  "getting-started/welcome-tour/03.png",
  "modules/clinic-flow/01.png",
  "modules/clinic-flow/02.png",
  "modules/clinic-flow/03.png",
  "modules/clinic-flow/04.png",
  "modules/clinic-flow/05.png",
  "modules/emergency-center/01.png",
  "modules/emergency-center/02.png",
  "modules/emergency-center/03.png",
  "modules/emergency-center/04.png",
  "modules/emergency-center/05.png",
  "modules/emergency-center/06.png",
  "modules/event-management/01.png",
  "modules/event-management/02.png",
  "modules/event-management/03.png",
  "modules/event-management/04.png",
  "modules/event-management/05.png",
  "modules/queue-management/01.png",
  "modules/queue-management/02.png",
  "modules/queue-management/03.png",
  "modules/queue-management/04.png",
  "modules/queue-management/05.png",
  "modules/wayfinding-kiosk/01.png",
  "modules/wayfinding-kiosk/02.png",
  "modules/wayfinding-kiosk/03.png",
  "modules/wayfinding-kiosk/04.png",
  "modules/wayfinding-kiosk/05.png",
  "modules/wayfinding/01.png",
  "modules/wayfinding/02.png",
  "modules/wayfinding/03.png",
  "modules/wayfinding/04.png",
  "modules/wayfinding/05.png",
  "modules/wayfinding/06.png",
  "modules/wayfinding/07.png",
  "modules/wayfinding/08.png",
  "modules/wayfinding/09.png",
  "screens/assign-content/01.png",
  "screens/assign-content/02.png",
  "screens/assign-content/03.png",
  "screens/assign-content/04.png",
  "screens/launch-a-virtual-screen/01.png",
  "screens/launch-a-virtual-screen/02.png",
  "screens/launch-a-virtual-screen/03.png",
  "screens/more-actions/01.png",
  "screens/more-actions/02.png",
  "screens/move-to-another-space/01.png",
  "screens/move-to-another-space/02.png",
  "screens/pair-a-screen/01.png",
  "screens/pair-a-screen/02.png",
  "screens/pair-a-screen/03.png",
  "screens/pair-a-screen/04.png",
  "screens/pair-a-screen/05.png",
  "screens/screen-details/01.png",
  "screens/screen-details/02.png",
  "screens/screen-details/03.png",
  "screens/screen-fit-studio/01.png",
  "screens/screen-fit-studio/02.png",
  "screens/screen-fit-studio/03.png",
  "screens/screen-fit-studio/04.png",
  "screens/screen-groups/01.png",
  "screens/screen-groups/02.png",
  "screens/screen-groups/03.png",
  "screens/screen-groups/04.png",
  "screens/screen-groups/05.png",
  "screens/screen-health/01.png",
  "screens/screen-health/02.png",
  "screens/view-wall/01.png",
  "screens/view-wall/02.png",
  "screens/view-wall/03.png",
  "screens/wall-studio/01.png",
  "screens/wall-studio/02.png",
  "screens/wall-studio/03.png",
]);
